import api from './api';

export type RegionLevel = 'province' | 'city' | 'district';

export interface RegionItem {
  id: string;
  parentId?: string | null;
  code: string;
  name: string;
  level: RegionLevel;
  sort: number;
  status: number;
  createdAt: string;
  updatedAt: string;
  children?: RegionItem[];
}

export interface RegionListParams {
  page?: number;
  pageSize?: number;
  level?: RegionLevel;
  parentId?: string;
  keyword?: string;
  status?: number;
}

export interface RegionListResponse {
  list: RegionItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateRegionRequest {
  parentId?: string;
  code: string;
  name: string;
  level: RegionLevel;
  sort?: number;
  status?: number;
}

export interface UpdateRegionRequest {
  parentId?: string;
  code?: string;
  name?: string;
  level?: RegionLevel;
  sort?: number;
  status?: number;
}

export const regionLevelOptions = [
  { label: '省级', value: 'province' as RegionLevel },
  { label: '市级', value: 'city' as RegionLevel },
  { label: '区级', value: 'district' as RegionLevel },
];

export const regionLevelLabelMap: Record<RegionLevel, string> = {
  province: '省级',
  city: '市级',
  district: '区级',
};

export const getRegions = (params?: RegionListParams) => api.get<RegionListResponse>('/regions', { params });

export const getRegionTree = (params?: { status?: number; refresh?: boolean }) => api.get<RegionItem[]>('/regions/tree', { params });

export const getRegion = (id: string) => api.get<RegionItem>(`/regions/${id}`);

export const createRegion = (data: CreateRegionRequest) => api.post<RegionItem>('/regions', data);

export const updateRegion = (id: string, data: UpdateRegionRequest) => api.put<RegionItem>(`/regions/${id}`, data);

export const deleteRegion = (id: string) => api.delete(`/regions/${id}`);
